import React, { useContext } from 'react';
import styles from '../../css/components/common/logo.css';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';
import { getAssetUrl } from '../../helpers/get-asset-url';
import {AppContext} from '../../Store';

function Logo() {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const title = onelpsParams.title;
	const [state] = useContext(AppContext);
	const isPreLanderActive = onelpsParams.preLander?.show && !state.preLanderCompleted;
	const logoClassName = { isBeta: 'betaLogo', isInternational: 'cropSafeLogo' }[onelpsParams.launchPhase.phase] ?? 'logo';
	const resolvedLogoClass = onelpsParams.bigbeat ? styles.bigbeatLogo : styles[logoClassName];
	const logoImage = onelpsParams.logo?.gameLogoSrc && (getAssetUrl() + require('../../img/' + GAMEID + '/logos/' + onelpsParams.logo.gameLogoSrc));
	const preLanderBigbeatClass = isPreLanderActive && onelpsParams.bigbeat ? styles[onelpsParams.bigbeat] || '' : '';

	return (
		<h1
			className={`${resolvedLogoClass} ${preLanderBigbeatClass}`}
			style={ logoImage && { backgroundImage: 'url(' + logoImage + ')' }}
		>
			{title}
		</h1>
	);
}

export default Logo;
